import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next';
import { useTkalDataContext } from '../../../context/tkalData';

interface InputProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLInputElement>, HTMLInputElement> {
}

type MeasurementFieldProps = {
    propertyName: string,
    unit?: string,
    placeholderKey?: string,
    inputProps?: InputProps,
    gap?: string,
    showValue?: boolean,
    type?: 'text' | 'number'
}

const MeasurementFieldSepu = ({
    propertyName,
    unit = '',
    placeholderKey = 'Value',
    inputProps = { className: 'ahutest-form__input --value' },
    gap = '25px',
    showValue = true,
    type = 'text'

}: MeasurementFieldProps) => {
    const { sepuTest, setSepuTest } = useTkalDataContext();
    const { t } = useTranslation();

    const IsDisabled = (measurementKey: string) => {
        return useMemo(() => {
            if (sepuTest.measurements[measurementKey]?.statusNew !== "disabled") {
                return true
            } else {
                return false;
            }
        }, [sepuTest, measurementKey])
    }

    const handleChangeMeasurementsValue = (event: any, propertyName: string) => {
        setSepuTest({
            ...sepuTest,
            "measurements": { ...sepuTest.measurements, [event.target.name]: { ...sepuTest.measurements[event.target.name], [propertyName]: event.target.value } }
        })
    }

    const handleChangeMeasurementsValueUnit = (event: any, propertyName: string, unit: string) => {
        setSepuTest({
            ...sepuTest,
            "measurements": { ...sepuTest.measurements, [event.target.name]: { ...sepuTest.measurements[event.target.name], [propertyName]: event.target.value, unit: unit } }
        })
    }

    return (
        <>
            {IsDisabled(propertyName) &&
                <div className="flexboxAlignedRow" style={{ gap: gap }}>
                    {showValue &&
                        <>
                            <input type={type} {...inputProps} name={propertyName} onChange={e => handleChangeMeasurementsValueUnit(e, "value", unit)} value={sepuTest.measurements[propertyName]?.value ?? ""} placeholder={t(placeholderKey)} />
                            {unit}</>}
                    <input className="ahutest-form__input" name={propertyName} onChange={e => handleChangeMeasurementsValue(e, "description")} value={sepuTest.measurements[propertyName]?.description ?? ""} placeholder={t("Notes")} />
                </div>
            }
        </>
    );
}

export default MeasurementFieldSepu